var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_885_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 0.666672C3.94996 0.666672 0.666626 3.95001 0.666626 8C0.666626 12.05 3.94996 15.3333 7.99996 15.3333C12.05 15.3333 15.3333 12.05 15.3333 8C15.3333 3.95001 12.05 0.666672 7.99996 0.666672ZM8.66663 4.66667C8.66663 4.48986 8.59639 4.32029 8.47136 4.19527C8.34634 4.07024 8.17677 4 7.99996 4C7.82315 4 7.65358 4.07024 7.52855 4.19527C7.40353 4.32029 7.33329 4.48986 7.33329 4.66667V8.66667C7.33329 8.84348 7.40353 9.01305 7.52855 9.13808C7.65358 9.2631 7.82315 9.33334 7.99996 9.33334C8.17677 9.33334 8.34634 9.2631 8.47136 9.13808C8.59639 9.01305 8.66663 8.84348 8.66663 8.66667V4.66667ZM8.66663 11C8.66663 10.8232 8.59639 10.6536 8.47136 10.5286C8.34634 10.4036 8.17677 10.3333 7.99996 10.3333C7.82315 10.3333 7.65358 10.4036 7.52855 10.5286C7.40353 10.6536 7.33329 10.8232 7.33329 11V11.3333C7.33329 11.5101 7.40353 11.6797 7.52855 11.8047C7.65358 11.9298 7.82315 12 7.99996 12C8.17677 12 8.34634 11.9298 8.47136 11.8047C8.59639 11.6797 8.66663 11.5101 8.66663 11.3333V11Z",
    fill: "#FAFF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_4421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.01c298fa59e3fd0b16dc600b6d0b33ae.svg";
export { ForwardRef as ReactComponent };